import React from 'react'

import { useSelector } from 'react-redux'
import { selectIsSuggestInputValueEmpty } from '../../store/suggest/suggest.selectors'
import T from '../i18n/T'
import s from './SuggestContentError.less'

const SuggestContentError = ({ hasSuggests, error }) => {
  const isInputValueEmpty = useSelector(selectIsSuggestInputValueEmpty)
  if (hasSuggests || isInputValueEmpty) return <></>

  return (
    <div className={s.SuggestError}>
      <T id={error?.name ?? 'suggest.no-result'} />
    </div>
  )
}

export default SuggestContentError
